export default "__VITE_ASSET__DW2FpDBZ__"